import { isly } from "isly";
export var GB;
(function (GB) {
    var _a;
    _a = isly
        .object({
        countryCode: isly.string("value", "GB"),
        street: isly.string(),
        building: isly.string(),
        zipCode: isly.string(),
        city: isly.string(),
    }, "isoly.Address.GB")
        .bind(), GB.type = _a.type, GB.is = _a.is, GB.flawed = _a.flawed;
})(GB || (GB = {}));
//# sourceMappingURL=GB.js.map